import { render, staticRenderFns } from "./pdfdocente.vue?vue&type=template&id=6fa44d18"
import script from "./pdfdocente.vue?vue&type=script&lang=js"
export * from "./pdfdocente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports